import api from "./client";

export interface BrandAsset {
  id: string;
  asset_type: "logo" | "cover_image" | "cover_image_mobile";
  public_url: string;
  file_name: string | null;
  content_type: string | null;
  file_size_bytes: number | null;
  created_at: string;
}

type BrandAssetsResponse = { assets: BrandAsset[] };

export async function fetchBrandAssets(businessId: string): Promise<BrandAsset[]> {
  const res = await api.get<BrandAssetsResponse>(`/businesses/${businessId}/brand-assets`);
  return res.data.assets;
}

export async function uploadBrandAsset(
  businessId: string,
  assetType: "logo" | "cover_image" | "cover_image_mobile",
  file: File
): Promise<BrandAsset> {
  const res = await api.post<BrandAsset>(
    `/businesses/${businessId}/brand-assets/${assetType}`,
    file,
    {
      headers: {
        "Content-Type": file.type,
        "X-File-Name": file.name,
      },
    }
  );
  return res.data;
}

export async function deleteBrandAsset(
  businessId: string,
  assetType: "logo" | "cover_image" | "cover_image_mobile"
): Promise<void> {
  await api.delete(`/businesses/${businessId}/brand-assets/${assetType}`);
}
